import {
  Box,
  Icon,
  Modal,
  ModalCloseButton,
  ModalContent,
  Typography,
} from "@outschool/backpack";
import { faCopy } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useCopyLinkToClipboard } from "@outschool/ui-components-website";
import React from "react";

import { FacebookMessengerButton } from "../../sharing/FacebookMessengerButton";
import { FacebookShareButton } from "../../sharing/FacebookShareButton";

type Props = {
  open: boolean;
  onClose: () => void;
  url: string;
};

export function ShareProfileModal({ open, onClose, url }: Props) {
  const { t } = useTranslation(
    "client\\routes\\ParentProfile\\ParentProfileCard\\ShareProfileModal",
  );

  const { wasCopied, onCopy } = useCopyLinkToClipboard();

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContent
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "342px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
          pt: 48,
        }}
      >
        <ModalCloseButton
          onClick={onClose}
          aria-label={t("Close")}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
          }}
        />
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          {t("Share my profile with a friend!")}
        </Typography>
        <TrackedButton
          onClick={() => onCopy(url)}
          variant="contained"
          startIcon={<Icon icon={faCopy} />}
          trackingName="share_link_copy_button"
        >
          {wasCopied ? t("Profile link copied!") : t("Copy profile link")}
        </TrackedButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <FacebookShareButton
            url={url}
            aria-label={t("Share your profile link to Facebook")}
            trackingName="share_via_facebook"
          >
            {t("Facebook")}
          </FacebookShareButton>
          <FacebookMessengerButton
            url={url}
            aria-label={t("Send your profile link on Facebook Messenger")}
            trackingName="share_via_messenger"
          >
            {t("Messenger")}
          </FacebookMessengerButton>
        </Box>
      </ModalContent>
    </Modal>
  );
}
